exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.searchArea textarea {\n    line-height: 24px !important;\n    margin-top: 16px !important;\n}\n\n", ""]);
